var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 67,
    viewBox: "0 0 64 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 67,
    rx: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.412 41.694C42.654 39.588 41.172 38.184 41.172 36.156C41.172 33.504 44.136 30.54 48.972 27.108L44.994 23.442C38.676 27.186 32.592 32.178 32.592 39.042C32.592 43.722 36.258 47.544 40.626 47.544C44.448 47.544 47.022 45.048 47.412 41.694ZM28.614 41.694C23.856 39.588 22.374 38.184 22.374 36.156C22.374 33.504 25.338 30.54 30.174 27.108L26.196 23.442C19.878 27.186 13.794 32.178 13.794 39.042C13.794 43.722 17.46 47.544 21.828 47.544C25.65 47.544 28.224 45.048 28.614 41.694Z",
    fill: "#CC3333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.4662dcd52db24897f34433480a2099ea.svg";
export { ForwardRef as ReactComponent };